import { Component } from "react";
import { extract } from "@parksandresorts/core";
import SiteBlocks from "components/blocks/site-blocks/site-blocks.js";
import ThemeHelper from "components/helpers/theme-helper";

export default class PageInOverlay extends Component {
  constructor(props) {
    super(props);

    ThemeHelper.setTheme(extract(props, "data.contentfulSiteConfiguration.siteTheme", "gronalund"));
    this.contentPage = extract(props, "data.contentfulContentPage");
    this.pageTheme = extract(this.contentPage, "pageTheme");
    const blocks = this.contentPage.blocks instanceof Array ? this.contentPage.blocks : [];
    const locationState = extract(this.props, "location.state");
    this.blocks = this.extendBlocks(blocks, { blockInOverlay: true, locationState: locationState });
  }

  extendBlocks(blocks, extendObject) {
    if (!extendObject) {
      return blocks;
    }

    const extendedBlocks = blocks.map((block) => {
      return Object.assign({}, extendObject, block);
    });

    return extendedBlocks;
  }

  render() {
    return (
      <div
        id="overlay-theme-wrapper"
        className={["site-theme-" + ThemeHelper.getTheme()]}
        data-contentful-id={this.contentPage.contentful_id}
      >
        <div className={this.pageTheme ? `page-theme-${this.pageTheme.toLowerCase()}` : "page-theme-none"}>
          {this.props.children}
          <main id="Main" className={this.context.isMainVisible === false ? "display-none" : ""}>
            {this.blocks instanceof Array && this.blocks && <SiteBlocks blocks={this.blocks} />}
          </main>
        </div>
      </div>
    );
  }
}
